import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-seller-details',
  templateUrl: './seller-details.component.html',
  styleUrls: ['./seller-details.component.scss']
})
export class SellerDetailsComponent implements OnInit {

  pageName = "Seller Details";
  modelForm: FormGroup;
  filesToUpload: Array<File> = [];

  firstname:any;
  lastname:any;
  date_joined:any;
  

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) { 
    $('#loader').show();
    //lets get the model for this page
  this._data.getProfile() 
  .pipe(first())
  .subscribe(
    data => {
      console.log(data);
      this.modelData = data['cover']['model']['modelData']['formFieldsEntities'];

      this.firstname = data['cover']['model']['modelData']['formFieldsEntities']['PersonalDetails']['first_name'];
      this.lastname = data['cover']['model']['modelData']['formFieldsEntities']['PersonalDetails']['last_name'];
      // this.date_joined = data['cover']['model']['modelData']['formFieldsEntities'];

      if(this.localModelDataStorage) {

        localStorage.setItem(this.modelName, JSON.stringify(data['cover']['model']['modelData'])); // save reference data in localStorage+

        this.modelData = JSON.parse(localStorage.getItem(this.modelName));

      }
    },
    error => {

      console.log(error);
        iziToast.success({
          title: 'Error!',
          position: 'topRight',
          icon: 'icon-circle-check',
          message: 'Failed to retrieve profile info.'
      });

      $('#loader').hide();

    },

    () => {
      this.prepopulate();
        $('#loader').hide();
    }
  );

  }

  localModelDataStorage = false;
  modelName = 'User';
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;

  phoneNumberPattern =this._data.validSAPhone
  websiteUrl = this._data.validWebUrl
  validName = this._data.validName
  validLastName = this._data.validLastName
  validEmail = this._data.validEmail


  ngOnInit() {

    $('#initialise-page').trigger('click');

  	  this.modelForm = this.formBuilder.group({

      email: ['', Validators.required], 
      first_name: ['', Validators.required], 
      last_name: ['', Validators.required], 
      phone: ['', Validators.required], 
      username: [''], 
      seller: [false], 

      address_1: ['', Validators.required], 
      address_2: ['', Validators.required], 
      city: [''], 
      state: ['' ], 
      postcode: ['', Validators.required], 
      building: [''],
      isshipping: [true, Validators.required],

    });
  }

  get f() { return this.modelForm.controls; }

  prepopulate(){

      for (var key in this.modelData) {  // 'field' is a string

        if (this.modelData[key] instanceof Array || this.modelData[key] instanceof Object) {
      
          var innerModelDataObject;

          if (this.modelData[key] instanceof Object) {
            innerModelDataObject = Object.values(this.modelData[key]);

            var innerModelDataObject2 = this.modelData[key];
            console.log(innerModelDataObject2);

            for (const [objectKey, value] of Object.entries(this.modelData[key])) {
              console.log(`${objectKey} ${value}`); // "a 5", "b 7", "c 9"

              for (const objectfield in this.modelForm.controls) {
  
                if(this.modelData[key][objectfield]) {
      
                  this.modelForm.get(objectfield).setValue(this.modelData[key][objectfield]);
                  console.log(objectfield);
                }
      
              }
            }
          }

          //not sure what to do with arrays as yet...

          if (this.modelData[key] instanceof Array) {

            // for (var objectKey in this.modelData[key]) {

            //   alert('value is Array!'+ objectKey);
  
            // }
          }
          
          
        }

        else {

          for (const field in this.modelForm.controls) {
            // console.log(key)
            if(this.modelData[field]) {

              this.modelForm.get(field).setValue(this.modelData[field]);
              //const control = this.modelForm.get(field); // 'control' is a FormControl
              // console.log(field);
    
              //console.log(control);
            }

          }

        }

        

      }
  }

  onFileChanged(event) {
    //this.files = event.target.files[0];
    //this.modelForm.get('images').setValue(this.files);

    this.filesToUpload = <Array<File>>event.target.files;
  }

  onSubmit() {

    //alert('working magic!')
    $('#buttonText').text('Please Wait...');
    $('#loader').show();

    if (this.modelForm.invalid) {
      console.log('errors are detected');
      this.markFormGroupTouched(this.modelForm);

      $('#buttonText').text('Update Details ');
      $('#loader').hide();

      return;
    }

    console.log('Details being saved in the service: '+JSON.stringify(this.modelForm.value))

    this.createModel(); // run combine function
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  createModel() {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    modelObject1.append('id', this.modelId);
    modelObject1.append('PersonalDetails-email', this.modelForm.controls['email'].value);
    modelObject1.append('PersonalDetails-first_name', this.modelForm.controls['first_name'].value);
    modelObject1.append('PersonalDetails-last_name', this.modelForm.controls['last_name'].value);
    modelObject1.append('PersonalDetails-phone', this.modelForm.controls['phone'].value);
    modelObject1.append('PersonalDetails-username', this.modelForm.controls['username'].value);

    modelObject1.append('is_seller', this.modelForm.controls['seller'].value);

    modelObject1.append('PersonalDetails-address_1', this.modelForm.controls['address_1'].value);
    modelObject1.append('PersonalDetails-address_2', this.modelForm.controls['address_2'].value);
    modelObject1.append('PersonalDetails-city', this.modelForm.controls['city'].value);
    modelObject1.append('PersonalDetails-state', this.modelForm.controls['state'].value);
    modelObject1.append('PersonalDetails-postcode', this.modelForm.controls['postcode'].value);

    modelObject1.append('PersonalDetails-building', this.modelForm.controls['building'].value);
    modelObject1.append('PersonalDetails-isshipping', this.modelForm.controls['isshipping'].value);

    //modelObject1.append('status', this.modelForm.controls['status'].value);

    const files: Array<File> = this.filesToUpload;
    console.log(files);

    for(let i =0; i < files.length; i++){
        modelObject1.append("avatar[]", files[i]);
    }


    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateProfile(modelObject) 
      .pipe(first())
      .subscribe(
        data => {
 
          this.returnData = data;
          console.log('this is the new model return object: '+JSON.stringify(this.returnData));

          // this.modelId = data['result']['id'];
          this.modelData =  data['cover']['model']['modelData']['formFieldsEntities'];

        },
        error => {
          console.log(error);

          $('#buttonText').text('Update Details ');
          $('#loader').hide();

        },

        () => {
          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your profile updated successfuly.'
          });

          $('#buttonText').text('Update Details ');
          $('#loader').hide();

          this.router.navigate(['/sellers/register/business-details']);
        }
      );
  }

}
